// extracted by mini-css-extract-plugin
module.exports =  {"badge":"U6cc0dy","all-caps":"HPm7ZZd","allCaps":"HPm7ZZd"};